import React from 'react'
import { injectIntl, IntlShape } from 'react-intl'
import GridActions from 'components/GridActions'
import { searchableColumns } from 'components/rentals/RentalsHosts/specs'
import { useSelector } from 'react-redux'
import { selectHostsFilters, selectTotalHosts } from 'store/rentals'
import messages from './messages'

interface RentalsActionsProps {
  intl: IntlShape
  toggleableColumns?: string[]
  displayedColumns?: string[]
  onSelection: (columns: string[]) => void
  onSearch?: (search: string) => void
  isHostDisplayed?: boolean
  onFieldsChange: () => void
  search?: string
  searchFields?: any[]
  setSearch?: (search: string) => void
  isShareDisabled: boolean
  onExport?: () => void
  setSearchFields?: (fields: any[]) => void
}

function RentalsActions({
  intl,
  toggleableColumns = [],
  displayedColumns = [],
  onSelection,
  onSearch,
  isHostDisplayed,
  onFieldsChange,
  search,
  searchFields,
  setSearch,
  isShareDisabled,
  onExport,
  setSearchFields,
}: RentalsActionsProps) {
  const onToggleColumns = (selections: { value: string }[]) => {
    const nextColumns = selections.map(selection => selection.value)
    onSelection(nextColumns)
  }

  const filters = useSelector(selectHostsFilters)
  const totalHosts = useSelector(selectTotalHosts)

  return (
    <GridActions
      withShare
      search={search}
      searchFields={searchFields}
      setSearch={setSearch}
      setSearchFields={setSearchFields}
      onSearch={onSearch}
      allColumns={toggleableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.columns[column]),
      }))}
      displayedColumns={displayedColumns}
      onColumnsChange={totalHosts > 0 ? onToggleColumns : () => {}}
      searchableFields={searchableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.columns[column]),
      }))}
      onShare={onExport}
      isShareDisabled={isShareDisabled}
      onFieldsChange={onFieldsChange}
      filters={filters}
      isReducedSearchSize={isHostDisplayed}
    />
  )
}

export default injectIntl(RentalsActions)
